import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const pValuation = r => require.ensure([], () => r(require('../views/pValuation')), 'pValuation')
const dValuation = r => require.ensure([], () => r(require('../views/dValuation')), 'dValuation')
const about = r => require.ensure([], () => r(require('../views/about')), 'about')
const userProtocol = r => require.ensure([], () => r(require('../views/protocol/userProtocol')), 'userProtocol')
const personalInfo = r => require.ensure([], () => r(require('../views/protocol/personalInfo')), 'personalInfo')
// const gradeQuery = r => require.ensure([], () => r(require('../views/gradeQuery')), 'gradeQuery')
const totalOrder = r => require.ensure([], () => r(require('../views/totalOrder')), 'totalOrder')
const totalAccountFlow = r => require.ensure([], () => r(require('../views/totalAccountFlow')), 'totalAccountFlow')
const compositeScore = r => require.ensure([], () => r(require('../views/compositeScore')), 'compositeScore')
const faq = r => require.ensure([], () => r(require('../views/faq')), 'faq')
const breakContract = r => require.ensure([], () => r(require('../views/breakContract')), 'breakContract')
const eIndex = r => require.ensure([], () => r(require('../views/taxi/index')), 'eIndex')
const eStart = r => require.ensure([], () => r(require('../views/taxi/start')), 'eStart')
const eSubject = r => require.ensure([], () => r(require('../views/taxi/subject')), 'eSubject')
const router = new Router({
  routes: [
    {
      path: '/eIndex',
      name: 'eIndex',
      component: eIndex,
      meta: {
        title: '麦卡技能考试宝典'
      }
    }, {
      path: '/eStart',
      name: 'eStart',
      component: eStart,
      meta: {
        title: '麦卡技能考试宝典'
      }
    },
    {
      path: '/eSubject',
      name: 'eSubject',
      component: eSubject,
      meta: {
        title: '麦卡技能考试宝典'
      }
    },
    {
      path: '/breakContract',
      name: 'breakContract',
      component: breakContract,
      meta: {
        title: '违约规则'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      meta: {
        title: '客服中心'
      }
    },
    {
      path: '/pValuation',
      name: 'pValuation',
      component: pValuation,
      meta: {
        title: '计价规则详情'
      }
    },
    {
      path: '/dValuation',
      name: 'dValuation',
      component: dValuation,
      meta: {
        title: '计价规则详情'
      }
    },
    {
      path: '/passengerValuation',
      name: 'passengerValuation',
      component: r => require.ensure([], () => r(require('../views/passengerValuation')), 'passengerValuation'),
      meta: {
        title: '计价规则详情'
      }
    },
    {
      path: '/priceFormula',
      name: 'priceFormula',
      component: r => require.ensure([], () => r(require('../views/priceFormula')), 'priceFormula'),
      meta: {
        title: '价格公式文案'
      }
    },
    {
      path: '/driverValuation',
      name: 'driverValuation',
      component: r => require.ensure([], () => r(require('../views/driverValuation')), 'driverValuation'),
      meta: {
        title: '计价规则详情'
      }
    },
    {
      path: '/driverPriceFormula',
      name: 'driverPriceFormula',
      component: r => require.ensure([], () => r(require('../views/driverPriceFormula')), 'driverPriceFormula'),
      meta: {
        title: '价格公式文案'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '关于'
      }
    },
    {
      path: '/userProtocol',
      name: 'userProtocol',
      component: userProtocol,
      meta: {
        title: '麦卡出行用户注册协议'
      }
    },
    {
      path: '/personalInfo',
      name: 'personalInfo',
      component: personalInfo,
      meta: {
        title: '个人信息保护及隐私政策'
      }
    },
    {
      path: '/gradeQuery',
      name: 'gradeQuery',
      component: r => require.ensure([], () => r(require('../views/gradeQuery')), 'gradeQuery'),
      meta: {
        title: '成绩查询'
      }
    },
    {
      path: '/totalOrder',
      name: 'totalOrder',
      component: totalOrder,
      meta: {
        title: '月总订单数'
      }
    },
    {
      path: '/totalAccountFlow',
      name: 'totalAccountFlow',
      component: totalAccountFlow,
      meta: {
        title: '月总流水数'
      }
    },
    {
      path: '/compositeScore',
      name: 'compositeScore',
      component: compositeScore,
      meta: {
        title: '月总流水数'
      }
    },
    {
      path: '/downloadPassenger',
      name: 'downloadPassenger',
      component: r => require.ensure([], () => r(require('../views/downloadPassenger')), 'downloadPassenger'),
      meta: {
        title: '麦卡出行APP下载',
        desc: ``
      }
    },
    // 简短下载地址，运营发短信用，节约字数
    {
      path: '/p',
      name: 'downloadPassenger',
      component: r => require.ensure([], () => r(require('../views/downloadPassenger')), 'downloadPassenger'),
      meta: {
        title: '麦卡出行APP下载',
        desc: ``
      }
    },
    {
      path: '/material',
      name: 'material',
      component: r => require.ensure([], () => r(require('../views/taxi/material')), 'material'),
      meta: {
        title: '学习材料'
      }
    },
    {
      path: '/usageRule',
      name: 'usageRule',
      component: r => require.ensure([], () => r(require('../views/taxi/usageRule')), 'usageRule'),
      meta: {
        title: '使用规则'
      }
    },
    {
      path: '/cancelRule',
      name: 'cancelRule',
      component: r => require.ensure([], () => r(require('../views/taxi/cancelRule')), 'cancelRule'),
      meta: {
        title: '取消规则'
      }
    },
    {
      path: '/userRecharge',
      name: 'userRecharge',
      component: r => require.ensure([], () => r(require('../views/taxi/userRecharge')), 'userRecharge'),
      meta: {
        title: '充值协议'
      }
    },
    {
      path: '/driverReflect',
      name: 'driverReflect',
      component: r => require.ensure([], () => r(require('../views/taxi/driverReflect')), 'driverReflect'),
      meta: {
        title: '提现规则'
      }
    },
    {
      path: '/tGradeQuery',
      name: 'tGradeQuery',
      component: r => require.ensure([], () => r(require('../views/taxi/gradeQuery')), 'tGradeQuery'),
      meta: {
        title: '成绩查询'
      }
    },
    {
      path: '/tCompositeScore',
      name: 'tCompositeScore',
      component: r => require.ensure([], () => r(require('../views/taxi/compositeScore')), 'tCompositeScore'),
      meta: {
        title: '月综合评分'
      }
    },
    {
      path: '/tTotalOrder',
      name: 'tTotalOrder',
      component: r => require.ensure([], () => r(require('../views/taxi/totalOrder')), 'tTotalOrder'),
      meta: {
        title: '月总订单数'
      }
    },
    {
      path: '/tTotalAccountFlow',
      name: 'tTotalAccountFlow',
      component: r => require.ensure([], () => r(require('../views/taxi/totalAccountFlow')), 'tTotalAccountFlow'),
      meta: {
        title: '月总流水数'
      }
    },
    {
      path: '/downloadApp',
      name: 'downloadApp',
      component: r => require.ensure([], () => r(require('../views/downloadApp')), 'downloadApp'),
      meta: {
        title: '司机下载'
      }
    },
    {
      path: '/invoiceRule',
      name: 'invoiceRule',
      component: r => require.ensure([], () => r(require('../views/invoiceRule')), 'invoiceRule'),
      meta: {
        title: '开票规则'
      }
    },
    {
      path: '/tDriverProtocol',
      name: 'tDriverProtocol',
      component: r => require.ensure([], () => r(require('../views/taxi/tDriverProtocol')), 'tDriverProtocol'),
      meta: {
        title: '出租车平台服务协议'
      }
    },
    {
      path: '/driverProtocol',
      name: 'driverProtocol',
      component: r => require.ensure([], () => r(require('../views/protocol/driverProtocol')), 'driverProtocol'),
      meta: {
        title: '专车服务合作协议'
      }
    },
    {
      path: '/sDriverReflect',
      name: 'sDriverReflect',
      component: r => require.ensure([], () => r(require('../views/supplier/driverReflect')), 'sDriverReflect'),
      meta: {
        title: '提现规则'
      }
    },
    {
      path: '/onlineSeconds',
      name: 'onlineSeconds',
      component: r => require.ensure([], () => r(require('../views/onlineSeconds')), 'onlineSeconds'),
      meta: {
        title: '在线时长'
      }
    },
    {
      path: '/recordProtocol',
      name: 'recordProtocol',
      component: r => require.ensure([], () => r(require('../views/protocol/recordProtocol')), 'recordProtocol'),
      meta: {
        title: '录音隐私协议'
      }
    },
    {
      path: '/serviceProtocol',
      name: 'serviceProtocol',
      component: r => require.ensure([], () => r(require('../views/didi/serviceProtocol')), 'serviceProtocol'),
      meta: {
        title: '录音隐私协议'
      }
    },
    {
      path: '/recordingAuth',
      name: 'recordingAuth',
      component: r => require.ensure([], () => r(require('../views/didi/recordingAuth')), 'recordingAuth'),
      meta: {
        title: '「麦卡出行」录音授权'
      }
    },
    {
      path: '/numberProtect',
      name: 'numberProtect',
      component: r => require.ensure([], () => r(require('../views/didi/numberProtect')), 'numberProtect'),
      meta: {
        title: '「麦卡出行」隐私号码保护'
      }
    },
    {
      path: '/securityCenter',
      name: 'securityCenter',
      component: r => require.ensure([], () => r(require('../views/didi/securityCenter')), 'securityCenter'),
      meta: {
        title: '「麦卡出行」安全中心'
      }
    },
    {
      path: '/alarmSys',
      name: 'alarmSys',
      component: r => require.ensure([], () => r(require('../views/didi/alarmSys')), 'alarmSys'),
      meta: {
        title: '「麦卡出行」一键报警'
      }
    },
    {
      path: '/recordDailog',
      name: 'recordDailog',
      component: r => require.ensure([], () => r(require('../views/protocol/recordDailog')), 'recordDailog'),
      meta: {
        title: '录音授权'
      }
    }, {
      path: '/userProtocolDidi',
      name: 'userProtocolDidi',
      component: r => require.ensure([], () => r(require('../views/didi/userProtocol')), 'userProtocolDidi'),
      meta: {
        title: '用户服务协议'
      }
    },
    {
      path: '/recordProtocolDidi',
      name: 'recordProtocolDidi',
      component: r => require.ensure([], () => r(require('../views/didi/recordProtocol')), 'recordProtocolDidi'),
      meta: {
        title: '录音信息收集及隐私保护协议'
      }
    },
    {
      path: '/personalInfoDidi',
      name: 'personalInfoDidi',
      component: r => require.ensure([], () => r(require('../views/didi/personalInfo')), 'personalInfoDidi'),
      meta: {
        title: '用户隐私政策'
      }
    },
    {
      path: '/businessLicense',
      name: 'businessLicense',
      component: r => require.ensure([], () => r(require('../views/businessLicense')), 'businessLicense'),
      meta: {
        title: '证照信息'
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js